/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { ChecklistItemDto } from './checklist.dto';

export const ChecklistMapper = entity<ChecklistItemDto>({
  addedDate: date(DateFormat.Date),
  updatedDate: date(DateFormat.Date),
});
